import {
  Divider,
  Button,
  Table,
  Modal,
  Form,
  Tooltip,
  Space,
  Popconfirm,
  Input,
  message,
  Select,
  InputNumber,
} from "antd";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import * as Helper from "../../helpers";
import {
  deleteAyet,
  getAyetler,
  insertAyet,
  updateAyet,
} from "../../store/slices/ayetSlice";
import { getSureler } from "../../store/slices/sureSlice";
const { TextArea } = Input;
const { Option } = Select;
const Ayetler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getAyetler({
        sort: [
          {
            field: "SureId",
            dir: "asc",
          },
        ],
      })
    );
    dispatch(getSureler({
      sort: [
        {
          field: "DizilisSirasi",
          dir: "asc",
        },
      ],
    }));
  }, [dispatch]);

  const sure = useSelector((state) => state.sure);

  const ayetler = useSelector((state) => state.ayet.ayetler);
  const ayet = useSelector((state) => state.ayet);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    setEditMode(false);
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditMode(true);
    form.setFieldsValue({
      ayetArapca: record.ayetArapca,
      ayetNumarasi: record.ayetNumarasi,
      ayetOkunusu: record.ayetOkunusu,
      id: record.id,
      sureId: record.sureId,
      not: record.not

    });
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((record) => {
        if (editMode) {
          let body = {
            ayetArapca: record.ayetArapca,
            ayetNumarasi: record.ayetNumarasi,
            ayetOkunusu: record.ayetOkunusu,
            id: record.id,
            not: record.not,
            sureId: record.sureId,
          };
          dispatch(updateAyet(body))
            .unwrap()
            .then((result) => {
              dispatch(
                getAyetler({
                  sort: [
                    {
                      field: "SureId",
                      dir: "asc",
                    },
                  ],
                })
              );
              setIsModalVisible(false);
              form.resetFields();
              setEditMode(false);
              message.success("Ayet güncellendi");
            })
            .catch(() => {
              // handle error here
            });
        } else {
          let body = {
            ayetArapca: record.ayetArapca,
            ayetNumarasi: record.ayetNumarasi,
            ayetOkunusu: record.ayetOkunusu,
            sureId: record.sureId,
            not: record.not,
          };
          dispatch(insertAyet(body))
            .unwrap()
            .then((result) => {
              dispatch(
                getAyetler({
                  sort: [
                    {
                      field: "SureId",
                      dir: "asc",
                    },
                  ],
                })
              );
              setIsModalVisible(false);
              form.resetFields();
              setEditMode(false);
              message.success("Ayet eklendi");
            })
            .catch(() => {
              // handle error here
            });
        }
      })
      .catch((info) => {});
  };

  const handleDelete = (id) => {
    let body = { id: id };

    dispatch(deleteAyet(body))
      .unwrap()
      .then((result) => {
        dispatch(
          getAyetler({
            sort: [
              {
                field: "SureId",
                dir: "asc",
              },
            ],
          })
        );
        message.success("Ayet silindi");
      })
      .catch((rejectedValueOrSerializedError) => {
        // handle error here
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };

  return (
    <div>
      <Button
        onClick={() => showModal()}
        type="primary"
        style={{
          marginBottom: 16,
        }}
      >
        Ekle
      </Button>
      <Divider />

      <Table
        loading={ayet.loading}
        dataSource={ayetler.items}
        rowKey="id"
        onChange={handleChange}
        columns={[
          {
            title: "Id",
            dataIndex: "id",
            key: "id",
          },
          {
            title: "Sure İsmi",
            dataIndex: "sureIsmi",
            key: "sureIsmi",
            filters: Helper.filter(ayetler.items, "sureIsmi"),
            filteredValue: filteredInfo.sureIsmi || null,
            onFilter: (value, record) => record.sureIsmi.includes(value),
            filterSearch: true,
            filterMultiple: true,
            sorter: (a, b) => a.sureIsmi.length - b.sureIsmi.length,
            ellipsis: true,
          },
          {
            title: "Ayet Numarasi",
            dataIndex: "ayetNumarasi",
            key: "ayetNumarasi",
            filters: Helper.filter(ayetler.items, "ayetNumarasi"),
            filteredValue: filteredInfo.ayetNumarasi || null,
            onFilter: (value, record) => record.ayetNumarasi.includes(value),
            filterSearch: true,
            filterMultiple: true,
            sorter: (a, b) => a.ayetNumarasi - b.ayetNumarasi,
            ellipsis: true,

          },
          {
            title: "Arapça",
            dataIndex: "ayetArapca",
            key: "ayetArapca",
            filters: Helper.filter(ayetler.items, "ayetArapca"),
            filteredValue: filteredInfo.ayetArapca || null,
            onFilter: (value, record) => record.ayetArapca.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
            sorter: (a, b) => a.ayetArapca.length - b.ayetArapca.length,
          },
          {
            title: "Türkçe Meal",
            dataIndex: "ayetOkunusu",
            key: "ayetOkunusu",
            filters: Helper.filter(ayetler.items, "ayetOkunusu"),
            filteredValue: filteredInfo.ayetOkunusu || null,
            onFilter: (value, record) => record.ayetOkunusu.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
            sorter: (a, b) => a.ayetOkunusu.length - b.ayetOkunusu.length,

          },
          {
            title: "Not",
            dataIndex: "not",
            key: "not",
            filters: Helper.filter(ayetler.items, "not"),
            filteredValue: filteredInfo.not || null,
            onFilter: (value, record) => record.not.includes(value),
            filterSearch: true,
            filterMultiple: true,
            ellipsis: true,
            sorter: (a, b) => a.not.length - b.not.length,
          },
          {
            key: "action",
            render: (_, record) => (
              <Space size="middle">
                <Tooltip title="Düzenle">
                  <Button
                    onClick={() => handleEdit(record)}
                    type="primary"
                    shape="circle"
                    icon={<EditOutlined />}
                  />
                </Tooltip>
                <Popconfirm
                  title="Ayeti Silmek İstediğinize Emin Misiniz ?"
                  onConfirm={() => handleDelete(record.id)}
                  okText="Evet"
                  cancelText="Hayır"
                >
                  <Tooltip title="Sil">
                    <Button
                      type="primary"
                      danger
                      shape="circle"
                      icon={<DeleteOutlined />}
                    />
                  </Tooltip>
                </Popconfirm>
              </Space>
            ),
          },
        ]}
      />

      <Modal
        title="Ekle"
        onCancel={handleCancel}
        visible={isModalVisible}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Vazgeç
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={ayet.loading}
            onClick={handleOk}
          >
            Kaydet
          </Button>,
        ]}
      >
        <Form
          name="basic"
          form={form}
          labelCol={{
            span: 6,
          }}
          initialValues={{ remember: true }}
          autoComplete="on"
        >
          <Form.Item hidden={true} name="id">
            <Input />
          </Form.Item>
          <Form.Item
            label="Sure"
            name="sureId"
            rules={[{ required: true, message: "Ayet boş geçilemez" }]}
          >
            <Select
              style={{
                width: 120,
              }}
              showSearch
              value="sureId"
              onChange={handleChange}
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {sure.sureler.items.map((item) => (
                <Option value={item.id}>{item.isim}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Ayet Numarası"
            name="ayetNumarasi"
            rules={[{ required: true, message: "Ayet numarası boş geçilemez" }]}
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            label="Arapça"
            name="ayetArapca"
            rules={[{ required: true, message: "Arapça boş geçilemez" }]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item
            label="Türkçe Meal"
            name="ayetOkunusu"
            rules={[
              { required: true, message: "Türkçe meal alanı boş geçilemez" },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item
            label="Not"
            name="not"
          >
            <TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Ayetler;
